import { LOCATION_CHANGE } from 'react-router-redux';
import { ALERTS_FETCHED, FETCHING_ALERTS_FAILED } from '../../actions/actionTypes';

const initialState = {
    alerts: [],
    locationParams: null
};

const locationParamsFromLocationChange = (action) => {
    if (action.payload && action.payload.pathname) {
        const paths = action.payload.pathname.split('/');

        if (paths.length > 2) {
            // For tours, /ticket/facility/tour/{id}
            if (paths[1] === 'ticket' && paths.length > 4) {
                return { location_id: paths[4], location_type: 'Ticket Facility' };
            }

            // For ticket facilities, /ticket/facility/{id}
            if (paths[1] === 'ticket' && paths.length > 3) {
                return { location_id: paths[3], location_type: 'Ticket Facility' };
            }

            // For camping, /camping/campground/{id}
            if (paths[1] === 'camping' && paths.length > 3) {
                return { location_id: paths[3], location_type: 'Campground' };
            }

            // For permits, /permits/{id}
            return { location_id: paths[2], location_type: 'Permit' };
        }
    }

    return null;
};

const alertsNotificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case ALERTS_FETCHED:
            return Object.assign({}, state, {
                alerts: action.alerts
            });

        case FETCHING_ALERTS_FAILED:
            return Object.assign({}, state, {
                alerts: []
            });

        case LOCATION_CHANGE:
            return Object.assign({}, state, {
                locationParams: locationParamsFromLocationChange(action),
                alerts: []
            });

        default:
            return state;
    }
};

export default alertsNotificationReducer;
